'use client';
import { Provider } from 'jotai';
import { usePathname } from 'next/navigation';
import { useHydrateAtoms } from 'jotai/utils';
import { sizesContentTypeAtom } from '@/state/atoms';

interface ISizesProvider {
  contentType: string;
  children: React.ReactNode;
}

export const SizesProvider = ({ contentType, children }: ISizesProvider) => {
  const path = usePathname();
  const uniqueKey = `${path}-${contentType}`;

  const Hydrator = ({ contentType }: { contentType: string }) => {
    let sizes = '';
    if (path === '/' && contentType === 'or-homeplanscarousel') {
      sizes = '(max-width: 799px) 100vw, (max-width: 1680px) 33vw, 560px'; // 1680px / 3 = 560px
    }
    if (path === '/' && contentType === 'featured_video') {
      sizes = '(max-width: 1760px) 100vw, 1760px';
    }
    if (path === '/' && contentType === 'content_media_block') {
      sizes = '(max-width: 1023px) 100vw, (max-width: 1760px) 50vw, 880px'; // 1760px / 2 = 880px
    }
    if (path === '/' && contentType === 'or-cardslist') {
      sizes =
        '(max-width: 767px) 100vw, (max-width: 1023px) 50vw, (max-width: 1760px) 25vw, 440px'; // 1760px / 4 = 440px
    }
    if (path === '/' && contentType === 'mini_cta_block_c') {
      sizes = '246px';
    }

    if (path === '/house-plans' && contentType === 'filtered_grid') {
      sizes =
        '(max-width: 767px) 100vw, (max-width: 1279px) 50vw, (max-width: 1760px) 33vw, 590px'; // 1760px / 3 = 586.6666666666666px ~ 590px
    }

    // match paths like '/house-plans/beverly'
    // this is overridden by a nested sizesComponentNameProvider
    if (
      path.startsWith('/house-plans/') &&
      path.split('/').filter(Boolean).length === 2 &&
      contentType === 'home_plan_detail'
    ) {
      sizes = 'foobar';
    }

    useHydrateAtoms([[sizesContentTypeAtom, { sizes, contentType, path }]]);

    return null;
  };

  return (
    <Provider key={uniqueKey}>
      <Hydrator contentType={contentType} />
      {children}
    </Provider>
  );
};
